module.exports = __webpack_public_path__ + "static/media/i_footer_like_on.c88d6e6b.png";